import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { AppView, AppMainView } from '../../../../components/AppView'
import AppHeader from '../../../../components/AppView/Header'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { browserHistory } from 'react-router'
import { Routes } from '../../../../constants/Routes'
import { HelpLinkMenu } from '../../../../components/GrDropdown/HelpLinkMenu/HelpLinkMenu'
import Helmet from 'react-helmet'
import { BLAZE_COMPANY } from '../../../../constants/general'
import { HelpLinks } from '../../../../constants/ExternalLinks'

interface IProps {
  currentCompanyStore?: CurrentCompanyStore
}

@inject('currentCompanyStore')
@observer
export class DashboardQuickBooks extends React.Component<React.PropsWithChildren<IProps>, {}> {
  render() {
    const company = this.props.currentCompanyStore!.company!

    return (
      <AppView column gray>
        <Helmet>
          <title>Integrations | Quickbooks</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        <AppHeader
          title='QuickBooks'
          onBackClick={() => browserHistory.push(Routes.DASHBOARD_INTEGRATIONS(company.id))}
          backVisible
        >
          <span className='spaced-button-wrapper'>
            <HelpLinkMenu
              helpLinkMenus={[
                {
                  href: HelpLinks.QUICKBOOKS,
                  title: 'QuickBooks Online',
                },
              ]}
            />
          </span>
        </AppHeader>
        <AppMainView>
          {this.props.currentCompanyStore!.company!.permissions.canAccessQuickBooks ? (
            this.props.children
          ) : (
            <div className='text-muted'>
              QuickBooks integrations have not yet been enabled for your account.
              <br />
              Please contact {BLAZE_COMPANY} support to update your account.
            </div>
          )}
        </AppMainView>
      </AppView>
    )
  }
}
